export const SUPPORT_WEBHOOK_URL =
  "https://services.leadconnectorhq.com/hooks/vYf4b1VNuBpqHRJ1xZIs/webhook-trigger/f7be280d-1d15-4d90-88c4-d3781c603b31";

export async function sendSupportRequest({
  supportType,
  message,
  user = null,
  school = null,
  schoolId = null,
  userDisplayName = null,
  userEmail = null,
  userRole = null,
}) {
  const response = await fetch(SUPPORT_WEBHOOK_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      support_type: supportType,
      message,
      user_id: user?.id ?? null,
      name: userDisplayName ?? user?.name ?? null,
      email: userEmail ?? user?.email ?? user?.school_email ?? null,
      phone: user?.mobile_phone || user?.phone || null,
      role: userRole ?? user?.role ?? null,
      school_id: schoolId ?? school?.id ?? null,
      school_name: school?.school_nickname || school?.legal_name || null,
      created_at: new Date().toISOString(),
      page_url: typeof window !== "undefined" ? window.location.href : null,
    }),
  });

  if (!response.ok) {
    throw new Error(`Webhook responded with ${response.status}`);
  }
}
